import { megaActions } from './mega/megaActions';
import { accountActions } from './my-system/auth/accountActions';
import { commonActions } from './my-system/common/commonActions';

export const actions = {
	common: commonActions,
	account: accountActions,
	mega: megaActions
};
